import type { HoleRange } from '@/lib/db/types';

export interface ClubIndexRound {
  member_id: string;
  gross_total: number;
  holes: HoleRange;
  course_rating: number;
  slope: number;
  played_at: string;
}

export function clubIndexRoundCount(rounds: ClubIndexRound[], memberId: string): number {
  return rounds.filter(
    (r) => r.member_id === memberId
      && r.holes === 'full'
      && r.gross_total != null
      && r.slope > 0
      && r.course_rating > 0,
  ).length;
}

export function clubIndex(rounds: ClubIndexRound[], memberId: string): number | null {
  const qualifying = rounds
    .filter(
      (r) => r.member_id === memberId
        && r.holes === 'full'
        && r.gross_total != null
        && r.slope > 0
        && r.course_rating > 0,
    )
    .map((r) => ({
      diff: (113 / r.slope) * (r.gross_total - r.course_rating),
      t: new Date(r.played_at).getTime(),
    }))
    .sort((a, b) => b.t - a.t)
    .slice(0, 20);

  if (qualifying.length < 3) return null;

  const n = qualifying.length;
  const useCount = n >= 20 ? 8
    : n >= 19 ? 7
    : n >= 17 ? 6
    : n >= 15 ? 5
    : n >= 12 ? 4
    : n >= 9 ? 3
    : n >= 6 ? 2
    : 1;
  const adjustment = n === 3 ? -2.0
    : n === 4 ? -1.0
    : n === 6 ? -1.0
    : 0;
  const lowest = qualifying.map((r) => r.diff).sort((a, b) => a - b).slice(0, useCount);
  const avg = lowest.reduce((s, d) => s + d, 0) / lowest.length;
  return Math.round(Math.max(-10, Math.min(54, avg + adjustment)) * 10) / 10;
}
